import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { ServiceOrdersTotalizersModule } from "../../../views/registration/service-orders/service-orders-totalizers/service-orders-totalizers.module";
import { ChatModule } from '../chat-widget/chat-message.module';
import { TableResponsive } from './table-responsive.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

@NgModule({
  declarations: [TableResponsive],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    ChatModule,
    ServiceOrdersTotalizersModule
  ],
  exports: [TableResponsive],
})
export class TableResponsiveModule { }
